import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import Partner from "@/domains/Partners/Partner";
import Company from "@/domains/Companies/Company";
import DeliveryType from "@/domains/DeliveryTypes/DeliveryType";
import ContractExternal from "@/domains/Contracts/ContractExternal";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";

/**
 * DAO для работы с внешними договорами
 */
class ContractsExternalDAO {

	static async get(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('contracts.getExternal', { id });
	}

	static async getList(
    filters?: {
      seller?: Partner,
      sellerCompany?: Company,
      buyer?: Partner,
      buyerCompany?: Company,
      numberPattern?: string,
      deliveryType?: DeliveryType,
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
      'contracts.getListExternal',
      {
        ...filters,
        seller:        filters?.seller ? { id: filters.seller.id } : undefined,
        sellerCompany: filters?.sellerCompany ? { id: filters.sellerCompany.id } : undefined,
        buyer:         filters?.buyer ? { id: filters.buyer.id } : undefined,
        buyerCompany:  filters?.buyerCompany ? { id: filters.buyerCompany.id } : undefined,
        deliveryType:  filters?.deliveryType ? { id: filters.deliveryType.id } : undefined
      },
      pagination,
      sort,
      true,
      null,
      null,
      false,
      { abortPrevious: true}
    );
	}

	static async add(contract: ContractExternal): Promise<RpcResponse> {
		return await RpcService.makeRequest('contracts.addExternal', { contract });
	}

	static async update(contract: ContractExternal): Promise<RpcResponse> {
		return await RpcService.makeRequest('contracts.updateExternal', { contract });
	}

	static async delete(id: number, changeReasonText: string): Promise<RpcResponse> {
		return await RpcService.makeRequest('contracts.deleteExternal', {
			id,
			changeReasonText
		});
	}
}

export default ContractsExternalDAO;
